import React from 'react';
import { motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
export function PainPoints() {
  const problems = ['Recetas de internet que nunca te quedan igual que en el video', 'Gastás en ingredientes y tirás la mitad porque la masa no levantó', 'Los glaseados te salen feos y no sabés qué estás haciendo mal', 'Cobrás cualquier cosa porque no tenés una fórmula de precios', 'El packaging te da vergüenza y no podés mostrar el producto en Instagram', 'Querés emprender pero arrancás y parás, arrancás y parás', 'La semana termina igual que empezó — sin ningún peso extra en el bolsillo'];
  return <section className="w-full bg-[#FDF1E4] donut-pattern py-4 md:py-8 relative" data-id="element-146">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative" data-id="element-147">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-148">
          <h2 className="text-3xl md:text-5xl font-bold text-[#3D2817] text-center mb-2 md:mb-4 leading-tight" data-id="element-149">
            ¿Cuántos domingos más vas a pasar mirando videos de minidonas sin
            animarte a empezar?
          </h2>

          <div className="text-center mb-3 md:mb-5 space-y-1 md:space-y-2" data-id="element-150">
            <p className="text-lg text-[#6B5747] leading-relaxed" data-id="element-151">
              Querés tener tu propio negocio. Algo tuyo. Algo que podés hacer
              desde casa, a tu ritmo, con tus propias manos. Pero cada vez que
              intentás arrancar, aparece lo mismo:
              <br data-id="element-152" />
              <br data-id="element-153" />
              La masa no te queda. Los glaseados se corren o quedan opacos. No
              sabés cuánto cobrar. Y terminás pensando que "capaz no es para
              vos".
            </p>
            <p className="text-xl md:text-2xl font-bold text-[#B45309]" data-id="element-154">
              No es falta de talento. Es falta de un sistema.
            </p>
          </div>

          <div className="mb-3 md:mb-5" data-id="element-155">
            <h3 className="text-2xl font-bold text-[#3D2817] mb-2 md:mb-3 text-center" data-id="element-156">
              ❌ Lo que pasa sin el Mega Pack:
            </h3>
            <div className="bg-white border border-[#E8D5BA] rounded-lg overflow-hidden shadow-sm" data-id="element-157">
              <div className="divide-y divide-[#F0E3CE]" data-id="element-158">
                {problems.map((problem, index) => <motion.div key={index} initial={{
                opacity: 0,
                x: -20
              }} whileInView={{
                opacity: 1,
                x: 0
              }} viewport={{
                once: true
              }} transition={{
                delay: index * 0.1,
                duration: 0.4
              }} className="flex items-start gap-3 p-3" data-id="element-159">
                    <XIcon className="w-5 h-5 text-[#D4937A] flex-shrink-0 mt-0.5" data-id="element-160" />
                    <p className="text-[#6B5747] text-sm" data-id="element-161">{problem}</p>
                  </motion.div>)}
              </div>
            </div>
          </div>

          
        </motion.div>
      </div>
    </section>;
}